import { Badge } from '@/components/ui/primitives';

type Variant = 'success' | 'warning' | 'destructive' | 'secondary' | 'default';

const ADJUDICATION: Record<string, { text: string; variant: Variant }> = {
  approved: { text: 'Approved', variant: 'success' },
  partially_approved: { text: 'Part-approved', variant: 'warning' },
  rejected: { text: 'Rejected', variant: 'destructive' },
  pended: { text: 'Still deciding', variant: 'warning' },
  pending: { text: 'Waiting', variant: 'secondary' },
  cancelled: { text: 'Cancelled', variant: 'secondary' },
  not_required: { text: 'No approval needed', variant: 'success' },
};

const SOURCE_STATE: Record<string, { text: string; variant: Variant }> = {
  not_sent: { text: 'Not sent', variant: 'secondary' },
  pending: { text: 'Waiting for the insurer', variant: 'warning' },
  approved: { text: 'Approved', variant: 'success' },
  partial: { text: 'Part-approved', variant: 'warning' },
  rejected: { text: 'Rejected', variant: 'destructive' },
  pended: { text: 'Still deciding', variant: 'warning' },
  cancelled: { text: 'Cancelled', variant: 'secondary' },
  not_required: { text: 'No approval needed', variant: 'success' },
};

const EXCHANGE: Record<string, { text: string; variant: Variant }> = {
  unsent: { text: 'Not sent', variant: 'secondary' },
  queued: { text: 'On its way', variant: 'warning' },
  sent: { text: 'Sent', variant: 'success' },
  failed: { text: 'Failed', variant: 'destructive' },
};

export function AdjudicationBadge({ status }: { status: string }) {
  const entry = ADJUDICATION[status] ?? { text: status, variant: 'secondary' as Variant };
  return <Badge variant={entry.variant}>{entry.text}</Badge>;
}

export function SourceStateBadge({ state }: { state: string }) {
  const entry = SOURCE_STATE[state] ?? { text: state, variant: 'secondary' as Variant };
  return <Badge variant={entry.variant}>{entry.text}</Badge>;
}

export function ExchangeBadge({ state }: { state: string }) {
  const entry = EXCHANGE[state] ?? { text: state, variant: 'secondary' as Variant };
  return <Badge variant={entry.variant}>{entry.text}</Badge>;
}

export const PRE_AUTH_KIND_LABEL: Record<string, string> = {
  new: 'New',
  update: 'Update',
  extension: 'Extension of stay',
  resubmission: 'Resubmission',
};
